import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import {
    BranchLink,
    Section,
    SectionTitle,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import chikuPeek from 'wanderu-assets/images/chiku-peek.png';

import TwoColumnLayout, {
    LeftColumn,
    RightColumn,
} from '../TwoColumnLayout/TwoColumnLayout';
import AppRatings from './AppRatings/AppRatings';
import phone from './images/phone-with-qr.png';
import phone2x from './images/phone-with-qr2x.png';
import phone3x from './images/phone-with-qr3x.png';

import styles from './DownloadTheApp.scss';

const propTypes = {
    campaign: PropTypes.string,
    className: PropTypes.string,
    t: PropTypes.func,
};

function DownloadTheApp(props) {
    const {
        campaign,
        className = '',
        t,
    } = props;

    return (
        <Section
            className={classNames(styles.section, className)}
            color="primary"
            id="download-the-app"
        >
            <TwoColumnLayout layoutClassName={styles.layout} useNewBreakpoints>
                <LeftColumn className={styles.leftColumn}>
                    <BranchLink className={styles.phoneContainer}>
                        <LazyLoad height={709}>
                            <img
                                alt=""
                                className={styles.phoneImage}
                                height="673"
                                src={phone}
                                srcSet={`${phone2x} 654w, ${phone3x} 981w`}
                                width="327"
                            />
                        </LazyLoad>
                    </BranchLink>
                </LeftColumn>

                <RightColumn className={styles.rightColumn}>
                    <SectionTitle className={styles.title}>
                        {t('app-download-section-header')}
                    </SectionTitle>
                    <Typography className={styles.subtitle} variant="h4">
                        {t('app-download-section-text')}
                    </Typography>
                    <AppRatings campaign={campaign} />
                </RightColumn>
            </TwoColumnLayout>
            <img alt="Chiku" className={styles.chiku} src={chikuPeek} />
        </Section>
    );
}

DownloadTheApp.propTypes = propTypes;

export default localize(DownloadTheApp, ['t'], 'baseApp');
